import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import toast from 'react-hot-toast';
import {
  resetSelectedCategoryRow,
  setSelectedCategoryRow,
  statusCategory,
} from '../../../Redux/CategoryRedux';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationDialog from '../ConfirmationDialog';
import {
  featureProducts,
  resetSelectedProductRow,
  setSelectedProductRow,
  statusProducts,
} from '../../../Redux/ProductRedux';
import {
  resetSelectedHomeSlideRow,
  setSelectedHomeSlideRow,
  statusHomeSlide,
} from '../../../Redux/HomeSlideRedux';
import {
  getSellerById,
  resetSelectedSeller,
  setSelectedSeller,
  statusSeller,
} from '../../../Redux/SellerRedux';
import {
  resetSelectedPartnersRow,
  setSelectedPartnersRow,
  statusPartners,
} from '../../../Redux/partnersRedux.js';
import { getBuyerById } from '../../../Redux/BuyerRedux.js';

const DataTable = ({
  rows,
  columns,
  tableType,
  setCategoryDialog,
  setShowForm,
}) => {
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmationType, setConfirmationType] = useState('delete');
  const [status, setStatus] = useState('Activate');
  const [featured, setFeatured] = useState('Featured');
  const user = JSON.parse(localStorage.getItem('user'));
  const { selectedCategoryRow } = useSelector((state) => state.categoryRedux);
  const { selectedProductRow } = useSelector((state) => state.productRedux);
  const { selectedHomeSlideRow } = useSelector((state) => state.homeSlideRedux);
  const { selectedPartnersRow } = useSelector((state) => state.partnersRedux);
  const { selectedSeller } = useSelector((state) => state.sellerRedux);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });
  const dispatch = useDispatch();

  const deleteSubmit = () => {
    const handleDelete = (selectedRow, resetAction, statusAction, userId) => {
      if (selectedRow && Object.keys(selectedRow).length > 0) {
        const data = { id: selectedRow.id };
        dispatch(statusAction(data, userId))
          .then(() => {
            dispatch(resetAction());
          })
          .catch((error) => {
            console.error(`Error updating ${statusAction.name} status:`, error);
          });
      }
    };
    const adminId = user.userId;
    handleDelete(
      selectedCategoryRow,
      resetSelectedCategoryRow,
      statusCategory,
      adminId
    );
    handleDelete(
      selectedProductRow,
      resetSelectedProductRow,
      statusProducts,
      adminId
    );
    handleDelete(
      selectedHomeSlideRow,
      resetSelectedHomeSlideRow,
      statusHomeSlide,
      adminId
    );
    handleDelete(
      selectedPartnersRow,
      resetSelectedPartnersRow,
      statusPartners,
      adminId
    );
    handleDelete(selectedSeller, resetSelectedSeller, statusSeller, adminId);
    setConfirmDialog(false);
  };

  const featureSubmit = () => {
    setConfirmDialog(false);
    const data = { id: selectedProductRow.id };
    const userId = user.userId;
    dispatch(featureProducts(data, userId))
      .then(() => {
        setConfirmationType('delete');
        dispatch(resetSelectedPartnersRow());
      })
      .catch((error) => {
        console.error('Error while submitting feature:', error);
      });
  };

  const handleHomeSlideEdit = (row) => {
    dispatch(setSelectedHomeSlideRow(row));
    setShowForm(true);
  };
  const handleCategoryEdit = (row) => {
    dispatch(setSelectedCategoryRow(row));
    setCategoryDialog(true);
  };
  const handleProductEdit = (row) => {
    dispatch(setSelectedProductRow(row));
    setShowForm(true);
  };
  const handlePartnerEdit = (row) => {
    dispatch(setSelectedPartnersRow(row));
    setShowForm(true);
  };

  const handleSellerView = async (row) => {
    if (row) {
      try {
        localStorage.removeItem('bI');
        const adminId = user.userId;
        const response = await dispatch(getSellerById(row.id, adminId));
        if (response) {
          setShowForm(true);
          localStorage.setItem('showForm', 'true');
          localStorage.setItem('vM', 'true');
          localStorage.setItem('sI', response._id);
        } else {
          toast.error('Something went wrong. Please try again.');
        }
      } catch (error) {
        console.error('Error selecting seller row:', error);
        toast.error('Something went wrong. Please try again.');
      }
    }
  };

  const handleBuyerView = async (row) => {
    if (row) {
      try {
        localStorage.removeItem('sI');
        const response = await dispatch(getBuyerById(row.id));
        if (response) {
          setShowForm(true);
          localStorage.setItem('showForm', 'true');
          localStorage.setItem('vM', 'true');
          localStorage.setItem('bI', response._id);
        } else {
          toast.error('Something went wrong. Please try again.');
        }
      } catch (error) {
        console.error('Error selecting buyer row:', error);
        toast.error('Something went wrong. Please try again.');
      }
    }
  };

  const handleCategoryDelete = (row) => {
    const statusIs = row.isActive || '';
    if (statusIs === 'Yes') {
      setStatus('Deactivate');
    } else {
      setStatus('Activate');
    }
    dispatch(setSelectedCategoryRow(row));
    setConfirmDialog(true);
  };

  const handleProductDelete = (row) => {
    const statusIs = row.isActive || '';
    if (statusIs === 'Yes') {
      setStatus('Deactivate');
    } else {
      setStatus('Activate');
    }
    dispatch(setSelectedProductRow(row));
    setConfirmDialog(true);
  };

  const handleFeatured = (row) => {
    const statusIs = row.isFeatured || '';
    if (statusIs === 'Yes') {
      setFeatured('Unfeatured');
    } else {
      setFeatured('Featured');
    }
    dispatch(setSelectedProductRow(row));
    setConfirmationType('featured');
    setConfirmDialog(true);
  };

  const handleHomeSlideDelete = (row) => {
    const statusIs = row.isActive || '';
    if (statusIs === 'Yes') {
      setStatus('Deactivate');
    } else {
      setStatus('Activate');
    }
    dispatch(setSelectedHomeSlideRow(row));
    setConfirmDialog(true);
  };

  const handleSellerDelete = (row) => {
    const statusIs = row.isActive || '';
    if (statusIs === 'Yes') {
      setStatus('Deactivate');
    } else {
      setStatus('Activate');
    }
    dispatch(setSelectedSeller(row));
    setConfirmDialog(true);
  };

  const handlePartnerDelete = (row) => {
    const statusIs = row.isActive || '';
    if (statusIs === 'Yes') {
      setStatus('Deactivate');
    } else {
      setStatus('Activate');
    }
    dispatch(setSelectedPartnersRow(row));
    setConfirmDialog(true);
  };
  const handleClose = () => {
    // setCategoryDialog(false);
    setConfirmDialog(false);
  };

  const categoryActions = [
    ...columns,
    ...(user.role === 'admin'
      ? [
          {
            field: 'actions',
            headerName: 'ACTIONS',
            width: 180,
            renderCell: (params) => (
              <div>
                <Button
                  variant='text'
                  onClick={() => handleCategoryEdit(params.row)}
                >
                  Edit
                </Button>
                <Button
                  variant='text'
                  onClick={() => handleCategoryDelete(params.row)}
                  sx={{
                    color:
                      params.row.isActive === 'Yes' ? '#C8102E' : '#008000',
                  }}
                >
                  {params.row.isActive === 'Yes' ? 'Deactivate' : 'Activate'}
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];
  const homeSlideActions = [
    ...columns,
    ...(user.role === 'admin'
      ? [
          {
            field: 'actions',
            headerName: 'ACTIONS',
            width: 180,
            renderCell: (params) => (
              <div>
                <Button
                  variant='text'
                  onClick={() => handleHomeSlideEdit(params.row)}
                >
                  Edit
                </Button>
                <Button
                  variant='text'
                  onClick={() => handleHomeSlideDelete(params.row)}
                  sx={{
                    color:
                      params.row.isActive === 'Yes' ? '#C8102E' : '#008000',
                  }}
                >
                  {params.row.isActive === 'Yes' ? 'Deactivate' : 'Activate'}
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];
  const newsEventsActions = [
    ...columns,
    ...(user.role === 'admin'
      ? [
          {
            field: 'actions',
            headerName: 'ACTIONS',
            width: 150,
            renderCell: (params) => (
              <div>
                <IconButton onClick={() => handleHomeSlideDelete(params.row)}>
                  <DeleteIcon sx={{ color: '#C8102E' }} />
                </IconButton>
                <IconButton
                // onClick={() => handleView(params.row)}
                >
                  <VisibilityIcon sx={{ color: '#1CA350 ' }} />
                </IconButton>
              </div>
            ),
          },
        ]
      : []),
  ];
  const sellerActions = [
    ...columns,
    ...(user.role === 'admin'
      ? [
          {
            field: 'actions',
            headerName: 'ACTIONS',
            width: 150,
            renderCell: (params) => (
              <div>
                <IconButton onClick={() => handleSellerView(params.row)}>
                  <VisibilityIcon sx={{ color: '#1CA350 ' }} />
                </IconButton>
                <Button
                  variant='text'
                  onClick={() => handleSellerDelete(params.row)}
                  sx={{
                    color:
                      params.row.isActive === 'Yes' ? '#C8102E' : '#008000',
                  }}
                >
                  {params.row.isActive === 'Yes' ? 'Deactivate' : 'Activate'}
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];
  const buyerActions = [
    ...columns,
    ...(user.role === 'admin'
      ? [
          {
            field: 'actions',
            headerName: 'ACTIONS',
            width: 150,
            renderCell: (params) => (
              <div>
                <IconButton onClick={() => handleBuyerView(params.row)}>
                  <VisibilityIcon sx={{ color: '#1CA350 ' }} />
                </IconButton>
              </div>
            ),
          },
        ]
      : []),
  ];
  const partnersActions = [
    ...columns,
    ...(user.role === 'admin'
      ? [
          {
            field: 'actions',
            headerName: 'ACTIONS',
            width: 180,
            renderCell: (params) => (
              <div>
                <Button
                  variant='text'
                  onClick={() => handlePartnerEdit(params.row)}
                >
                  Edit
                </Button>
                <Button
                  variant='text'
                  onClick={() => handlePartnerDelete(params.row)}
                  sx={{
                    color:
                      params.row.isActive === 'Yes' ? '#C8102E' : '#008000',
                  }}
                >
                  {params.row.isActive === 'Yes' ? 'Deactivate' : 'Activate'}
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];
  const productActions = [
    ...columns,
    ...(user.role === 'seller' || user.role === 'admin'
      ? [
          {
            field: 'actions',
            headerName: 'ACTIONS',
            width: 240, // Adjust width to fit the additional button
            renderCell: (params) => (
              <div>
                {user.role === 'seller' && (
                  <Button
                    variant='text'
                    onClick={() => handleProductEdit(params.row)}
                  >
                    Edit
                  </Button>
                )}

                <Button
                  variant='text'
                  onClick={() => handleProductDelete(params.row)}
                  sx={{
                    color:
                      params.row.isActive === 'Yes' ? '#C8102E' : '#008000',
                  }}
                >
                  {params.row.isActive === 'Yes' ? 'Deactivate' : 'Activate'}
                </Button>

                {user.role === 'admin' && (
                  <Button
                    variant='text'
                    onClick={() => handleFeatured(params.row)}
                    sx={{
                      color:
                        params.row.isFeatured === 'Yes' ? '#008000' : '#C8102E',
                    }}
                  >
                    {params.row.isFeatured === 'Yes'
                      ? 'Featured'
                      : 'Unfeatured'}
                  </Button>
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  const dataColumns =
    tableType === 'addCategory'
      ? categoryActions
      : tableType === 'manageProducts'
      ? productActions
      : tableType === 'homeSlide'
      ? homeSlideActions
      : tableType === 'seller'
      ? sellerActions
      : tableType === 'buyer'
      ? buyerActions
      : tableType === 'partners'
      ? partnersActions
      : newsEventsActions;
  // const dataColumns =
  //   tableType === 'addCategory' ? categoryActions : productActions;
  const totalRowCount = rows.length;
  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        autoHeight
        rows={rows}
        columns={dataColumns}
        pageSizeOptions={[10, 15, 20]}
        pagination
        paginationModel={paginationModel}
        onPaginationModelChange={(model) => {
          setPaginationModel(model);
        }}
        rowCount={totalRowCount}
        disableRowSelectionOnClick
      />

      <ConfirmationDialog
        open={confirmDialog}
        onClose={handleClose}
        onConfirm={
          confirmationType === 'featured' ? featureSubmit : deleteSubmit
        }
        // onConfirm={deleteSubmit}
        description={
          confirmationType === 'featured'
            ? 'Are you sure you want to featured this ?'
            : `Are you sure you want to ${status} this ?`
        }
      />
    </div>
  );
};

export default DataTable;
